import type { Item } from '@/components/Surface/Header/NavigationMenu'
import { musicNavigationData } from './musicNavigation.data'
import { sportsNavigationData } from './sportsNavigation.data'

const nameOverrides: Record<string, string> = {
  Festivals: 'Festival',
  Performers: 'Performer',
}

const mapToTickets = (item: Item): Item => {
  const baseName = nameOverrides[item.name] ?? item.name
  return {
    ...item,
    name: `${baseName} Tickets`,
    link: item.link.replace('travel-packages', 'tickets'),
    children: item.children.map((child) => ({
      ...child,
      link: child.link.replace('travel-packages', 'tickets'),
    })),
  }
}

export const ticketsNavigationData = [
  {
    name: 'Tickets',
    items: [
      ...sportsNavigationData[0].items.map(mapToTickets),
      ...musicNavigationData[0].items.map(mapToTickets),
    ],
  },
]
